var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-6 w-6 stroke-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }